import { AxDropdown } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

export class LessonProperty {
    constructor(id: number, name: string, lessonPropertyType: LessonPropertyType) {
        this.id = id;
        this.name = name;
        this.lessonPropertyType = lessonPropertyType;
    }

    id: number;
    name: string;
    lessonPropertyType: LessonPropertyType;
}

export enum LessonPropertyType {
    Allergy = 1,
    MedicalState = 2,
    Language = 3
}

export interface CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;
}

export class InitCustomerProps implements CustomerLessonPropertiesInit {
    parentId: string;
    formElementPrefix: string;

    constructor(parentId: string, formElementPrefix: string) {
        this.parentId = parentId;
        this.formElementPrefix = formElementPrefix;
    }
}

@ModuleName("CustomerLessonProperties")
export class CustomerLessonProperties implements AxInit {

    private lessonAllergiesDropDown: AxDropdown;
    private lessonLanguagesDropDown: AxDropdown;
    private lessonMedicalsDropDown: AxDropdown;
    private lessonLevelsDropDown: AxDropdown;

    private hiddenAllergies: HTMLElement;
    private hiddenMedicalStates: HTMLElement;
    private hiddenLanguages: HTMLElement;
    //private hiddenLessonLevels: HTMLElement;

    private formElementPrefix: string;

    private allDropdowns: AxDropdown[] = [];

    allergies: LessonProperty[] = [];
    medicalStates: LessonProperty[] = [];
    languages: LessonProperty[] = [];
    lessonLevels: LessonProperty[] = [];

    AxInit(init: CustomerLessonPropertiesInit): void {
        this.formElementPrefix = init.formElementPrefix;

        this.hiddenAllergies = document.querySelector(`${init.parentId} .hidden_allergies`) as HTMLElement;
        this.hiddenMedicalStates = document.querySelector(`${init.parentId} .hidden_medicalStates`) as HTMLElement;
        this.hiddenLanguages = document.querySelector(`${init.parentId} .hidden_languages`) as HTMLElement;
        //this.hiddenLessonLevels = document.querySelector(`${init.parentId} .hidden_lessonLevels`) as HTMLElement;

        this.initLessonPropertyDropdowns(init.parentId);
    }

    //public getAllDropdowns(): AxDropdown[] {
    //    return this.allDropdowns;
    //}

    private initLessonPropertyDropdowns(parentId: string) {
        this.initAllergiesDropdown(parentId);
        this.initLanguagesDropdown(parentId);
        this.initMedicalsDropdown(parentId);
        this.initLevelsDropdown(parentId);
    }

    private initAllergiesDropdown(parentId: string) {
        this.lessonAllergiesDropDown = new AxDropdown();
        this.lessonAllergiesDropDown.init(`${parentId} .lesson-property-dropDown_allergies`,
            {
                searchBar: false,
                multiSelect: true,
                onOpen: () => { },
                onChange: (elem, changedValue, dir, values) => {
                    this.hiddenAllergies.innerHTML = "";
                    this.allergies = [];

                    if (Array.isArray(values)) {
                        values.forEach((value, i) => {
                            const temp = new LessonProperty(Number(value), "", LessonPropertyType.Allergy);
                            this.allergies.push(temp);
                            this.createFormElementProp("LessonAllergies", i, temp, this.hiddenAllergies);
                        });
                    } else {
                        const temp = new LessonProperty(Number(values), "", LessonPropertyType.Allergy);
                        this.createFormElementProp("LessonAllergies", 0, temp, this.hiddenAllergies);
                    }
                },
                
            });

        this.allDropdowns.push(this.lessonAllergiesDropDown);
    }

    private initLanguagesDropdown(parentId: string) {
        this.lessonLanguagesDropDown = new AxDropdown();
        this.lessonLanguagesDropDown.init(`${parentId} .lesson-property-dropDown_languages`,
            {
                searchBar: false,
                multiSelect: true,
                onOpen: () => { },
                onChange: (elem, changedValue, dir, values) => {
                    this.hiddenLanguages.innerHTML = "";
                    this.languages = [];

                    if (Array.isArray(values)) {
                        values.forEach((value, i) => {
                            const temp = new LessonProperty(Number(value), "", LessonPropertyType.Language);
                            this.languages.push(temp);
                            this.createFormElementProp("LessonLanguages", i, temp, this.hiddenLanguages);
                        });
                    } else {
                        const temp = new LessonProperty(Number(values), "", LessonPropertyType.Language);
                        this.createFormElementProp("LessonLanguages", 0, temp, this.hiddenLanguages);
                    }
                }
            });

        this.allDropdowns.push(this.lessonLanguagesDropDown);
    }

    private initMedicalsDropdown(parentId: string) {
        this.lessonMedicalsDropDown = new AxDropdown();
        this.lessonMedicalsDropDown.init(`${parentId} .lesson-property-dropDown_medicalStates`,
            {
                searchBar: false,
                multiSelect: true,
                onOpen: () => { },
                onChange: (elem, changedValue, dir, values) => {
                    if (Array.isArray(values)) {
                        this.hiddenMedicalStates.innerHTML = "";
                        this.medicalStates = [];

                        values.forEach((value, i) => {
                            const temp = new LessonProperty(Number(value), "", LessonPropertyType.MedicalState);
                            this.medicalStates.push(temp);
                            this.createFormElementProp("LessonMedicals", i, temp, this.hiddenMedicalStates);
                        });
                    } else {
                        const temp = new LessonProperty(Number(values), "", LessonPropertyType.MedicalState);
                        this.createFormElementProp("LessonMedicals", 0, temp, this.hiddenMedicalStates);
                    }
                }
            });

        this.allDropdowns.push(this.lessonMedicalsDropDown);
    }

    private initLevelsDropdown(parentId: string) {
        this.lessonLevelsDropDown = new AxDropdown();
        this.lessonLevelsDropDown.init(`${parentId} .lesson-property-dropDown_lessonLevels`,
            {
                searchBar: false,
                multiSelect: true,
                onOpen: () => { },
                onSelect: (elem, values) => {

                    //if (Array.isArray(values)) {
                    //    this.hiddenLessonLevels.value = values.join(',');
                    //} else {
                    //    this.hiddenLessonLevels.value = values;
                    //}
                }
            });

        this.allDropdowns.push(this.lessonLevelsDropDown);
    }

    private createFormElementProp(propFieldName: string, index: number, lessonProperty: LessonProperty, parent: HTMLElement) {
        this.createFormElementPropId(propFieldName, index, lessonProperty.id.toString(), parent);
        this.createFormElementPropName(propFieldName, index, lessonProperty.name, parent);
        this.createFormElementPropType(propFieldName, index, lessonProperty.lessonPropertyType, parent);

    }

    private createFormElementPropId(propName: string, index: number, value: string, parent: HTMLElement) {
        const propElement = document.createElement('input');
        propElement.type = "hidden";
        propElement.name = `${this.formElementPrefix}${propName}[${index}].id`;
        propElement.value = value;

        parent.appendChild(propElement);
    }

    private createFormElementPropName(propName: string, index: number, value: string, parent: HTMLElement) {
        const propElement = document.createElement('input');
        propElement.type = "hidden";
        propElement.name = `${this.formElementPrefix}${propName}[${index}].name`;
        propElement.value = value;

        parent.appendChild(propElement);
    }

    private createFormElementPropType(propName: string, index: number, propType: LessonPropertyType, parent: HTMLElement) {
        const propElement = document.createElement('input');
        propElement.type = "hidden";
        propElement.name = `${this.formElementPrefix}${propName}[${index}].lessonPropertyType`;
        propElement.value = propType.toString();

        parent.appendChild(propElement);
    }
}